<div class="single-inspection-list-view">
	<div *ngIf="viewModelError; then errorMessage; else content"></div>

	<!-- ERROR MESSAGE -->
	<ng-template #errorMessage>
		<div class="error-message">
			{{ "there was an issue with this inspection's data:" | i18next: { format: "capitalize" } }}
			<br />
			<br />
			{{ viewModelErrorDetails }}
			<br />
			<br />
			{{ "please contact your account administrator" | i18next: { format: "capitalize" } }}
		</div>
	</ng-template>

	<!-- INSPECTION DETAILS -->
	<ng-template #content>
		<div class="inspection-data">
			<div class="inspection-data-toggle">
				<h2 class="section-title">{{ "inspection details" | i18next: { format: "capitalize" } }}</h2>
				<div class="inspection-details-toggle">
					<button type="button"
						class="inspection-details-toggle-button"
						(click)="rotate()"
						[attr.aria-expanded]="rotateState === 'up'">
						<span>{{ (rotateState === "up" ? "less" : "more") | i18next: { format: "capitalize" } }}</span>
						<mat-icon class="pointer" [@rotatedState]="rotateState">
							expand_more
						</mat-icon>
					</button>
				</div>
			</div>

			<!-- INSPECTION INFORMATION ACCORDION -->
			<div class="asset-detail-table" [@detailExpand]="expansionAnimation()">
				<dl class="detail-table">
					<ng-container *ngFor="let info of staticInfo">
						<div class="detail-table-tr">
							<dt class="detail-table-field">{{ info.detailItemField }}</dt>
							<dd class="detail-table-data">
								{{ info.detailItemContent }}
							</dd>
						</div>
					</ng-container>
					<ng-container *ngFor="let detail of viewModel.inspectionDetailData">
						<div class="detail-table-tr">
							<dt class="detail-table-field">{{ detail.languageLabel }}</dt>
							<dd class="detail-table-data">
								{{ detail.inspectionDetailContent }}
							</dd>
						</div>
					</ng-container>
					<ng-container *ngFor="let photo of formDataPhotos">
						<ng-container *ngIf="photo.images">
							<div class="detail-table-tr form-data-photos">
								<dt class="detail-table-field">{{ photo.label }}</dt>
								<dd class="detail-table-data" aria-hidden="true"></dd>
							</div>
							<div class="detail-table-full-row">
								<div class="photo-row">
									<ng-container *ngFor="let image of photo.images; let i = index">
										<button type="button"
											class="photo-button"
											(click)="handleInspectionImageClick(photo, i)"
											(keydown.enter)="handleInspectionImageClick(photo, i)"
											(keydown.space)="$event.preventDefault(); handleInspectionImageClick(photo, i)"
											[attr.aria-label]="'Open inspection photo ' + (i + 1)">
											<img class="thumbnail photo form-data-photos-image"
												[src]="image.sanitizedImage"
												alt="inspection photo {{ i + 1 }}" />
										</button>
									</ng-container>
								</div>
							</div>
						</ng-container>
						<div class="detail-table-tr" *ngIf="!photo.images">
							<dt class="detail-table-field">{{ photo.label }}</dt>
							<dd class="detail-table-data">{{ photo.defaultValue }}</dd>
						</div>
					</ng-container>
				</dl>
			</div>
		</div>

		<!-- ASSET INSPECTION -->
		<ng-container *ngFor="let asset of viewModel.inspectionAssets; let assetIndex = index">
			<h2 class="asset-name">{{ asset.languageLabel }}</h2>

			<!-- ZONE NO DEFECT CARD -->
			<ng-container *ngIf="!asset.hasDefects && defectsOnly">
				<div class="no-zone-defect-card">
					<span>
						{{
							"there currently are no defects associated with this asset."
								| i18next: { format: "capitalize" }
						}}
					</span>
					<app-severity-zone-icon [severity]="'none'"></app-severity-zone-icon>
				</div>
			</ng-container>

			<!-- ZONE CARD -->
			<ng-container *ngFor="let zone of asset.inspectionZones; let zoneIndex = index">
				<div
					class="zone-card"
					*ngIf="showZoneCard(zone)"
				>
					<div
						class="zone-data"
						[ngClass]="{
							'no-zone-defects': !zone.inspectionDefects
						}"
					>
						<h3 class="zone-name">{{ zone.languageLabel }}</h3>
						<app-severity-zone-icon [severity]="zone.severity"></app-severity-zone-icon>
					</div>

					<!--ZONE DEFECTS-->
					<div
						class="zone-defects"
						*ngIf="zone.inspectionDefects"
					>
						<div *ngFor="let defect of zone.inspectionDefects">
							<ng-container *ngIf="defect">
								<mat-divider class="horizontal-divider"></mat-divider>
								<div class="component-defect">
									<div class="component-label">
										<span>{{ defect.componentLabel }} > {{ defect.conditionLabel }}</span>
										<!-- SEVERITY TRANSITION ICONS -->
										<ng-container
											*ngIf="defect.repair && defect.repair.statusTitle === closedStatus"
										>
											<div class="defect-status-change">
												<img class="component-severity-icon" [src]="defect.severityIcon"
													alt="{{defect.severity}}" />
												<img class="arrow-icon" src="/assets/arrow.svg" alt="transition arrow" />
												<img class="component-severity-icon" src="/assets/severity-none.svg"
													alt="Severity none" />
											</div>
										</ng-container>
										<!-- SEVERITY ICON -->
										<ng-container
											*ngIf="!defect.repair || defect.repair.statusTitle !== closedStatus">
											<img class="component-severity-icon" [src]="defect.severityIcon"
												alt="{{defect.severity}}" />
										</ng-container>
									</div>
									<span
										*ngIf="defect.defectComment"
										class="defect-comment"
									>
										"{{ defect.defectComment }}"
									</span>
									<span *ngIf="zone.time && zone.verificationType !== 'Uninspected'">
										{{ "inspected at" | i18next: { format: "capitalize" } }} {{ zone.time }}
									</span>
								</div>

								<!-- DEFECT DETAILS -->
								<dl *ngIf="defect.repair" class="detail-table defect-detail-table">
									<ng-container *ngFor="let repair of defect.repair.renderMap">
										<div class="detail-table-tr">
											<dt class="detail-table-field">
												{{ repair.label }}
											</dt>
											<dd class="detail-table-data">
												{{ repair.value }}
											</dd>
										</div>
									</ng-container>
								</dl>
								<dl *ngIf="!defect.repair" class="detail-table defect-detail-table">
									<ng-container *ngFor="let repair of renderMap">
										<div class="detail-table-tr">
											<dt class="detail-table-field">
												{{ repair.label }}
											</dt>
											<dd class="detail-table-data">
												{{ repair.value }}
											</dd>
										</div>
									</ng-container>
									<div class="detail-table-tr">
										<dt class="detail-table-field">
											{{ photoLabel }}
										</dt>
										<dd class="detail-table-data">
											{{ defect.photos && defect.photos?.length > 0 ? "" : "—" }}
										</dd>
									</div>
								</dl>
								<ng-container *ngIf="defect.photos && defect.photos?.length > 0">
									<div class="photo-row">
										<ng-container *ngFor="let photo of defect.photos; let photoIndex = index">
											<img id="defect-thumbnail" class="photo" [src]="photo.sanitizedImage"
												(click)="handleImageClick(defect, photoIndex)"
												alt="defect photo {{ photoIndex + 1 }}" />
										</ng-container>
									</div>
								</ng-container>
							</ng-container>
						</div>
					</div>

					<!--ZONE COMPONENTS-->
					<mat-accordion *ngIf="zone.componentsWithoutDefects?.length > 0">
						<mat-expansion-panel
							class="zone-expansion-panel"
							[ngClass]="{
								'zone-verification': !zone.inspectionDefects
							}"
							(click)="handleZoneClick(assetIndex, zoneIndex)"
							(opened)="panelOpenState = true"
							(closed)="panelOpenState = false"
						>
							<mat-expansion-panel-header>
								<mat-panel-title *ngIf="!zone.inspectionDefects">
									<span
										class="zone-inspected-time"
										*ngIf="zone.time"
									>
										{{ "inspected at" | i18next: { format: "capitalize" } }} {{ zone.time }}
									</span>
									<span *ngIf="!zone.time">{{ zone.verificationType }}</span>
									{{ zoneDetailsLabel[assetIndex][zoneIndex] | i18next: { format: "capitalize" } }}
								</mat-panel-title>
								<mat-panel-title *ngIf="zone.inspectionDefects">
									{{ zoneDetailsLabel[assetIndex][zoneIndex] | i18next: { format: "capitalize" } }}
								</mat-panel-title>
							</mat-expansion-panel-header>
							<ng-container *ngIf="zone.componentsWithoutDefects?.length > 0">
								<div
									class="component-info"
									*ngFor="let component of zone.componentsWithoutDefects"
								>
									<span class="component-name">{{ component }}</span>
									<mat-icon
										*ngIf="zone.verificationType === 'Uninspected'"
										class="component-status"
									>
										remove_circle_outline
									</mat-icon>
									<img *ngIf="zone.verificationType !== 'Uninspected'" class="component-status"
										src="/assets/severity-none.svg" alt="severity none" />
								</div>
							</ng-container>
						</mat-expansion-panel>
					</mat-accordion>
				</div>
			</ng-container>
		</ng-container>
	</ng-template>
</div>
